import { useEffect, useState } from 'react';
import { usePAChecklist } from "../pa_checklist_context";
import styles from '../pa_checklist.module.scss'
import Tabela from '../../../Misc/Tabela/Tabela';
import { Modal, Button, Form } from 'react-bootstrap';
import SelectInput from '../../../Misc/SelectInput/SelectInput';
import MaterialIcon from 'material-icons-react';
import ImageCompAnalise from './pa_checklist_comp_imagens_analise';

const PAChecklistModalProvaDeRoupa = () => {
  const { referenciaSelecionada, setModalCancelamento, abrirModalInformacoes, modalProvaDeRoupa, listaStatusAnalise, listaDefeitosProvaRoupa, listaLocalizacoesProvaRoupa, processarProvaDeRoupa, setIdsCancelamento } = usePAChecklist();

  const [statusAprovacao, setStatusAprovacao] = useState(null);
  const [defeitoSelecionado, setDefeitoSelecionado] = useState([]);
  const [localizacaoSelecionada, setLocalizacaoSelecionada] = useState(null);

  const [imagensProvaDeRoupa, setImagensProvaDeRoupa] = useState([]);
  const [imagensExtras, setImagensExtras] = useState([]);
  const [defeitosInseridos, setDefeitosInseridos] = useState([]);
  const [consideracoes, setConsideracoes] = useState('');

  const handleFileChange = (event, index) => {
    const file = event.target.files[0];
    if (file) {
      imagensProvaDeRoupa[index].imagem = file;
      setImagensProvaDeRoupa([...imagensProvaDeRoupa]);
    }
  }

  const removerImagem = (index) => {
    imagensProvaDeRoupa[index].imagem = null;
    setImagensProvaDeRoupa([...imagensProvaDeRoupa]);
  }

  const inserirDefeitoPR = () => {
    defeitosInseridos.push({
      defeitos: [...defeitoSelecionado],
      localizacao: localizacaoSelecionada
    });
    setDefeitoSelecionado(null);
    setLocalizacaoSelecionada(null);
    setDefeitosInseridos([...defeitosInseridos]);
  }

  const defeitosColumns = [
    {
      name: '', selector: (row, index) => {
        return <i onClick={() => removerDefeito(index)}>
          <MaterialIcon
            icon={'delete'}
            size={20}
            color='#DC3545'
          />
        </i>
      }, width: '50px'
    },
    { name: 'Localização', selector: row => row.localizacao.label || '-', width: '150px' },
    {
      name: 'Defeito(s)', cell: row => {
        return <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', margin: '6px auto 6px 0px' }}>
          {row.defeitos.map((def, i) => <div key={`def_pr_${i}`}>{def.label}</div>)}
        </div>
      }
    }
  ];

  const removerDefeito = (index) => {
    defeitosInseridos.splice(index, 1);
    setDefeitosInseridos([...defeitosInseridos]);
  }

  const handleFileChangeOpt = (event, index) => {
    const file = event.target.files[0];
    if (file) {
      imagensExtras[index].imagem = file;
      setImagensExtras([...imagensExtras]);
    }
  }

  const removerImagemOpt = (index) => {
    imagensExtras[index].imagem = null;
    setImagensExtras([...imagensExtras]);
  }

  const removerImagemPermanenteOpt = (index) => {
    const novasImagens = imagensExtras.filter((_, i) => i !== index);
    setImagensExtras(novasImagens);
  }

  useEffect(() => {
    setImagensProvaDeRoupa((prev) => {
      const novasEntradas = [];

      // Regra pra solicitar foto da peça de corpo inteiro:
      // Produções que tiveram peças com destino devolução ou com desconto na etapa de Análise;
      // OU
      // Produtos exclusivamente da marca Farm que possuam o tipo de corte localizado ou engenharia;
      // OU
      // Status Revisão devolução parcial ou total;

      // if (statusAprovacao?.value !== 4 || referenciaSelecionada.id_tipo_corte !== 5) {
      if (statusAprovacao?.value !== 4 && referenciaSelecionada.exigirImagemCorpoInteiro) {
        novasEntradas.push({
          key: '0-0',
          localizacao: 'CORPO INTEIRO (FRENTE)',
          defeito: 'GLOBAL',
          defeitoId: 'GLOBAL',
          imagem: null,
        });
      }

      defeitosInseridos.forEach((item) => {
        item.defeitos.forEach((defeito) => {
          novasEntradas.push({
            key: `${item.localizacao.value}-${defeito.value}`,
            localizacao: item.localizacao.label,
            defeito: defeito.label,
            defeitoId: defeito.value,
            imagem: null,
          });
        });
      });

      return novasEntradas.map((entry) => {
        const existing = prev.find((p) => p.key === entry.key);
        return existing || entry;
      });
    });
  }, [defeitosInseridos, statusAprovacao]);

  return (
    <Modal
      show={modalProvaDeRoupa}
      centered
      fullscreen={'lg-down'}
      size={'lg'}
    >
      <Modal.Header style={{ fontWeight: '500' }}>
        <div>
          Checklist - Prova de Roupa {referenciaSelecionada.nf_segunda_qualidade ? '(Segunda Qualidade)' : ''} | NF: {referenciaSelecionada.nf_entrada} | Produto: {referenciaSelecionada.produto} | Cor: {referenciaSelecionada.cor_produto}
        </div>
        <Button
          variant={'danger'}
          className={styles.footer_btn_processamento}
          onClick={() => {
            setIdsCancelamento([referenciaSelecionada.id_controle]);
            setModalCancelamento(true);
          }}
        >
          Cancelar Análise
        </Button>
      </Modal.Header>
      <Modal.Body className={styles.modal_body}>
        <section className={styles.dados_analise_wrapper} style={{ width: '768px' }}>
          <div style={{ fontWeight: '500' }}>
            <div>Desenvolvimento {referenciaSelecionada.is_desenvolvimento_interno ? 'Interno' : 'Externo'}</div>
            <div>Tipo de Produto | <span>{referenciaSelecionada.tipo_produto}</span></div>
            <div>Tipo de Corte | <span>{referenciaSelecionada.desc_tipo_corte || '-'}</span></div>
          </div>

          <SelectInput
            label={'Status Aprovação de Vestibilidade'}
            value={statusAprovacao}
            onChange={e => setStatusAprovacao(e)}
            options={listaStatusAnalise.filter(item => [4, 5, 8].includes(item.value))}
            // Nao sei explicar a causa desse bug visual, mas a linha abaixo o resolve;
            style={{ zIndex: '4' }}
          />

          <div className={styles.separator} />

          <div className={styles.sub_form_label} style={{ textAlign: 'center' }}>Defeitos encontrados durante a prova </div>
          {
            !statusAprovacao &&
            <label
              style={{ margin: 'auto', backgroundColor: '#FFC107', padding: '8px 16px', borderRadius: '10px' }}
              className={styles.sub_form_label}
            >
              Selecione um status
            </label>
          }
          {
            statusAprovacao && statusAprovacao?.value === 4 &&
            <label
              style={{ margin: 'auto', backgroundColor: '#B4E380', padding: '8px 16px', borderRadius: '10px' }}
              className={styles.sub_form_label}
            >
              Não é necessário adicionar defeitos para o status aprovado.
            </label>
          }
          {
            statusAprovacao && statusAprovacao?.value !== 4 && <>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-end', justifyContent: 'space-evenly' }}>
                <SelectInput
                  label={'Defeito(s)'}
                  style={{ width: '42%' }}
                  value={defeitoSelecionado}
                  onChange={e => setDefeitoSelecionado([...e])}
                  options={listaDefeitosProvaRoupa}
                  isMulti={true}
                  isDisabled={!statusAprovacao || statusAprovacao?.value === 4}
                  isSearchable={true}
                />
                <SelectInput
                  label={'Localização'}
                  style={{ width: '42%' }}
                  value={localizacaoSelecionada}
                  onChange={e => setLocalizacaoSelecionada({ ...e })}
                  options={listaLocalizacoesProvaRoupa}
                  isOptionDisabled={opt => defeitosInseridos.some(def => def.localizacao.value === opt.value)}
                  isDisabled={!statusAprovacao || statusAprovacao?.value === 4}
                />
                <Button
                  variant={'warning'}
                  className={styles.footer_btn_processamento}
                  onClick={() => inserirDefeitoPR()}
                  style={{ height: '38px', width: '16%' }}
                  disabled={!statusAprovacao || statusAprovacao?.value === 4}
                >
                  Adicionar
                </Button>
              </div>
              <Tabela
                backgroundColor={'#FFC107'}
                color={'#000'}
                columns={defeitosColumns}
                data={defeitosInseridos}
                pagination={false}
              />
            </>
          }

          <div className={styles.separator} />

          <div className={styles.sub_form_label} style={{ textAlign: 'center' }}>Imagens dos Defeitos</div>
          <div style={{ display: "flex", flexWrap: "wrap", justifyContent: 'left', columnGap: '0.5%', rowGap: '10px' }}>
            {/* {statusAprovacao && (statusAprovacao?.value === 4 && referenciaSelecionada.id_tipo_corte !== 5) && ( */}
            {statusAprovacao && statusAprovacao?.value === 4 && (
              <label
                style={{ margin: 'auto', backgroundColor: '#B4E380', padding: '8px 16px', borderRadius: '10px' }}
                className={styles.sub_form_label}
              >
                Não é necessário inserir imagens quando não há defeitos na produção.
              </label>
            )}

            {
              !statusAprovacao &&
              <label
                style={{ margin: 'auto', backgroundColor: '#FFC107', padding: '8px 16px', borderRadius: '10px' }}
                className={styles.sub_form_label}
              >
                Selecione um status
              </label>
            }

            {
              statusAprovacao && statusAprovacao?.value !== 4 && imagensProvaDeRoupa.length === 0 &&
              <label
                style={{ margin: 'auto', backgroundColor: '#FFC107', padding: '8px 16px', borderRadius: '10px' }}
                className={styles.sub_form_label}
              >
                Adicione ao menos um defeito
              </label>
            }
            {
              imagensProvaDeRoupa.map((item, index) => {
                if (!statusAprovacao || (statusAprovacao && statusAprovacao.value === 4) && item.localizacao !== 'CORPO INTEIRO (FRENTE)') return null;

                return (
                  <ImageCompAnalise
                    key={`imagem_modal_${index}`}
                    item={item}
                    index={index}
                    onFileChange={handleFileChange}
                    onRemove={removerImagem}
                    type="prova-roupa"
                    localizacao={item.localizacao}
                    defeito={item.defeito}
                  />
                );
              })
            }

            <div className={styles.separator} />

            <div
              style={{
                display: 'flex', width: '100%', justifyContent: 'center', gap: '16px', marginBottom: '10px', alignItems: 'center'
              }}
            >
              <label className={styles.sub_form_label}>Imagens Opcionais</label>
              <span
                style={{ backgroundColor: '#0D6EFD30', padding: '4px 6px', borderRadius: '4px', cursor: 'pointer' }}
                onClick={() => {
                  imagensExtras.push({ combination: 'opt', imagem: null });
                  setImagensExtras([...imagensExtras]);
                }}
              >
                + Adicionar Imagem
              </span>
            </div>
            {
              imagensExtras.map((item, index) => {
                return (
                  <ImageCompAnalise
                    key={`imagem_modal_opt_${index}`}
                    item={item}
                    index={index}
                    onFileChange={handleFileChangeOpt}
                    onRemove={removerImagemOpt}
                    onRemovePermanent={removerImagemPermanenteOpt}
                    type="optional"
                  />
                );

              })
            }
            {
              imagensExtras.length === 0 &&
              <label
                style={{ margin: 'auto', backgroundColor: '#B4E380', padding: '8px 16px', borderRadius: '10px' }}
                className={styles.sub_form_label}
              >
                Nenhuma imagem extra inserida.
              </label>
            }
          </div>

          <div className={styles.separator} />

          <Form.Group className={styles.sub_form_label}>
            <Form.Label>Considerações (Opcional)</Form.Label>
            <Form.Control
              as={'textarea'}
              placeholder={'Insira aqui quaisquer observações adicionais.'}
              rows={6}
              value={consideracoes || ''}
              onChange={e => setConsideracoes(e.target.value)}
            />
          </Form.Group>
        </section>
      </Modal.Body>
      <Modal.Footer className={styles.modal_footer}>
        <Button
          variant={'primary'}
          className={styles.footer_btn_processamento}
          onClick={() => abrirModalInformacoes(referenciaSelecionada)}
        >
          Informações
        </Button>
        <Button
          variant={'success'}
          className={styles.footer_btn_processamento}
          onClick={() => processarProvaDeRoupa({
            statusAprovacao,
            defeitoSelecionado,
            localizacaoSelecionada,
            imagensProvaDeRoupa,
            imagensExtrasPdR: imagensExtras,
            defeitosInseridos,
            consideracoes
          })}
        >
          Processar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PAChecklistModalProvaDeRoupa;
